"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import Script from "next/script";
import { useState, useEffect } from "react";
import "../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../Chrome/BrowseContext/hook.js";
const QueueItClient = ({
  queueItScript,
  queueItConfigScript
}) => {
  const [isWindowAvailable, setIsWindowAvailable] = useState(false);
  const [hostName, setHostName] = useState(
    (queueItConfigScript == null ? void 0 : queueItConfigScript["data-queueit-intercept-domain"]) || null
  );
  const { thirdPartyInfo } = useBrowseContext();
  const {
    consentManagement: { isTargetingEnabled }
  } = thirdPartyInfo;
  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsWindowAvailable(true);
      setHostName(window.location.hostname);
    }
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: isWindowAvailable && isTargetingEnabled && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Script,
      {
        id: "QueueItScript",
        type: "text/javascript",
        ...queueItScript,
        src: queueItScript.src,
        strategy: "afterInteractive"
      }
    ),
    /* @__PURE__ */ jsx(
      Script,
      {
        id: "QueueItConfigScript",
        type: "text/javascript",
        ...queueItConfigScript,
        src: queueItConfigScript.src,
        "data-queueit-intercept-domain": hostName,
        strategy: "afterInteractive"
      }
    )
  ] }) });
};
export {
  QueueItClient
};
